export default __webpack_public_path__ + "static/media/apple-logo-tablet.dce53bb0.svg";